module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('user-editor', {
    attrs: {
      "mode": "edit"
    },
    on: {
      "saveClicked": _vm.saveUser,
      "cancelClicked": _vm.onCancelClick
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0fa2218e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fa2218e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/accounts/edit-user-dialog.vue.html
// module id = 1076
// module chunks = 0